import _objectSpread from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { useCheckboxGroup as useCheckboxGroupWeb } from '@react-aria/checkbox';
import { mapDomPropsToRN } from '@react-native-aria/utils';
/**
 * Provides the behavior and accessibility implementation for a checkbox group component.
 * Checkbox groups allow users to select multiple items from a list of options.
 * @param props - Props for the checkbox group.
 * @param state - State for the checkbox group, as returned by `useCheckboxGroupState`.
 */

export function useCheckboxGroup(props, state) {
  var params = useCheckboxGroupWeb(props, state);
  return {
    labelProps: _objectSpread(_objectSpread({}, params.labelProps), mapDomPropsToRN(params.labelProps)),
    groupProps: _objectSpread(_objectSpread({}, params.groupProps), mapDomPropsToRN(params.groupProps))
  };
}